import React from "react";
import { createRoot } from "react-dom/client";
import "./globals.css";

import App from "./App";
import { cuidarDaVersaoNova } from "./services/versaoNova";

// Antes de montar a árvore: a aba precisa saber se recuperar de uma troca de
// versão mesmo na tela de login, onde o aviso de atualização nem existe.
cuidarDaVersaoNova();

createRoot(document.getElementById("root")).render(<App />);
